// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-featured-tsx": () => import("./../../../src/pages/featured.tsx" /* webpackChunkName: "component---src-pages-featured-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-ingredients-tsx": () => import("./../../../src/pages/ingredients.tsx" /* webpackChunkName: "component---src-pages-ingredients-tsx" */),
  "component---src-pages-recipe-tsx": () => import("./../../../src/pages/recipe.tsx" /* webpackChunkName: "component---src-pages-recipe-tsx" */)
}

